import { useState, useEffect } from "react";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import {
  AppContext,
  AppGeneralTextContext,
  ImagesContext,
} from "./app_context/app_context";
import jsonData from "./app_data/app_data.json";
import generalTextData from "./app_data/generalTextData.json";
import imagesData from "./app_data/images_data.json";
import {
  addRequestEndListener,
  addRequestStartListener,
} from "./utils/apiServices";
import { NotificationProvider } from "./app_context/NotificationContext";
import Notification from "./components/common/Notification";
import Application from "./Application";
import Loader from "./components/common/Loder";
import { HMIContextProvider } from "./app_context/HMIContext";
import { UserProvider} from "./app_context/UserContext";
const App = () => {

  const [showLoader, setShowLoader] = useState<boolean>(false);
    const getURL = window.location.href;
    const urlParams = new URL(getURL).searchParams;
    const urlUserId = urlParams.get("userId");
    const urlRoles = urlParams.get("roles");
    
    // Extract subroute from pathname
    const pathname = window.location.pathname;
    const subroute = pathname.split('/').filter(segment => segment)[0] || '';
    
    // Store userId, roles, and subroute from URL if present
    if (urlUserId) {
      localStorage.setItem("url_userId", urlUserId);
         // Store subroute in localStorage
    localStorage.setItem("subroute", subroute);
    }
    if (urlRoles) {
      localStorage.setItem("url_roles", urlRoles);
    }
 
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "light");
    addRequestStartListener(() => {
      setShowLoader(true);
    });
    addRequestEndListener(() => {
      setShowLoader(false);
    });



  }, []);


  return (
   <>
      <BrowserRouter>
        <UserProvider>
          <AppGeneralTextContext.Provider value={generalTextData}>
            <ImagesContext.Provider value={imagesData}>
              <AppContext.Provider value={jsonData as any}>
                <NotificationProvider>
                  <HMIContextProvider>
                    <>
                      <Application />
                      <Notification />
                    </>
                  </HMIContextProvider>
                </NotificationProvider>
              </AppContext.Provider>
            </ImagesContext.Provider>
          </AppGeneralTextContext.Provider>
        </UserProvider>
      </BrowserRouter>
      {showLoader && <Loader showOverlay />}
    </>
  );
};

export default App;
